/* Custom By MAS — envío del presupuesto por email sin depender del programa de correo del cliente.
   Usa el formulario de contacto nativo de Shopify: el mensaje llega directamente al email de la tienda.
   Shopify protege ese formulario con hCaptcha: lo activamos al cargar (data-shopify-captcha)
   y enviamos con requestSubmit() para que la verificación añada su token. */
(function () {
  if (window.__cbmPresEmail) return;
  window.__cbmPresEmail = true;

  // Se ejecuta antes de DOMContentLoaded (script defer): Shopify vinculará el CAPTCHA a estos formularios.
  document.querySelectorAll('form[id^="cbm-contacto-"]').forEach(function (f) { f.dataset.shopifyCaptcha = 'true'; });

  var EMAIL_OK = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function valor(form, name) {
    var el = form.elements[name];
    if (!el) return '';
    return (el.value || '').trim();
  }

  function mensaje(form) {
    var lineas = [form.dataset.saludo || 'Hola, me gustaría pedir un presupuesto.', ''];
    [
      ['nombre', 'Nombre'], ['email_cliente', 'Email'], ['tipo', 'Tipo de encargo'],
      ['idea', 'Mi idea / necesidad'], ['medidas', 'Medidas aproximadas'], ['cantidad', 'Cantidad'],
      ['colores', 'Colores'], ['fecha', 'Lo necesito para'], ['ciudad', 'Envío a']
    ].forEach(function (c) {
      var v = valor(form, c[0]);
      if (v) lineas.push(c[1] + ': ' + v);
    });
    return lineas.join('\n');
  }

  function mostrar(el, on) { if (el) el.classList.toggle('is-on', !!on); }

  function submitir(cf) {
    if (typeof cf.requestSubmit === 'function') { cf.requestSubmit(); return; }
    var b = document.createElement('button');
    b.type = 'submit'; b.hidden = true;
    cf.appendChild(b); b.click(); cf.removeChild(b);
  }

  // Espera a que Shopify haya vinculado el CAPTCHA (hasta 8 s) y envía.
  function enviar(cf) {
    if (cf.dataset.hcaptchaBound || cf.dataset.recaptchaBound) { submitir(cf); return; }
    cf.dispatchEvent(new Event('focusin', { bubbles: true }));
    var t0 = Date.now();
    (function esperar() {
      if (cf.dataset.hcaptchaBound || cf.dataset.recaptchaBound || Date.now() - t0 > 8000) { submitir(cf); return; }
      setTimeout(esperar, 200);
    })();
  }

  // Escucha en fase de captura sobre el documento: se adelanta al antiguo envío por "mailto".
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cbm-enviar="email"]');
    if (!btn) return;
    var form = btn.closest('[data-cbm-presupuesto]');
    if (!form) return;
    var cf = document.getElementById(form.dataset.contactForm || '');
    if (!cf) return; // sin formulario nativo: se deja el comportamiento antiguo
    e.preventDefault();
    e.stopPropagation();

    var errIdea = form.querySelector('.cbm-form__error');
    var errEmail = form.querySelector('.cbm-form__error--email');
    var ok = true;
    if (!valor(form, 'idea')) { mostrar(errIdea, true); form.elements['idea'].focus(); ok = false; }
    else mostrar(errIdea, false);
    var email = valor(form, 'email_cliente');
    if (!EMAIL_OK.test(email)) {
      mostrar(errEmail, true);
      if (ok) form.elements['email_cliente'].focus();
      ok = false;
    } else mostrar(errEmail, false);
    if (!ok) return;

    cf.querySelector('[name="contact[email]"]').value = email;
    cf.querySelector('[name="contact[name]"]').value = valor(form, 'nombre');
    cf.querySelector('[name="contact[body]"]').value = mensaje(form);
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    setTimeout(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); }, 12000);
    enviar(cf);
  }, true);
})();
